export const FooterLink2 = [
  {
    title: "Subjects",
    links: [
      { title: "AI", link: "https://www.geeksforgeeks.org/artificial-intelligence/" },
      { title: "Cloud Computing", link: "https://www.geeksforgeeks.org/cloud-computing/" },
      { title: "Code Foundations", link: "https://www.geeksforgeeks.org/programming-basics/" },
      { title: "Computer Science", link: "https://www.geeksforgeeks.org/computer-science-projects/" },
      { title: "Cybersecurity", link: "https://www.geeksforgeeks.org/cyber-security/" },
      { title: "Data Analytics", link: "https://www.geeksforgeeks.org/data-analysis-and-visualization/" },
      { title: "Data Science", link: "https://www.geeksforgeeks.org/data-science/" },
      { title: "Data Visualization", link: "https://www.geeksforgeeks.org/data-visualization/" },
      { title: "Developer Tools", link: "https://www.geeksforgeeks.org/developer-tools/" },
      { title: "DevOps", link: "https://www.geeksforgeeks.org/what-is-devops/" },
      { title: "Game Development", link: "https://www.geeksforgeeks.org/game-development/" },
      { title: "IT", link: "https://www.geeksforgeeks.org/information-technology-it/" },
      { title: "Machine Learning", link: "https://www.geeksforgeeks.org/machine-learning/" },
      { title: "Math", link: "https://www.geeksforgeeks.org/mathematics/" },
      { title: "Mobile Development", link: "https://www.geeksforgeeks.org/mobile-app-development/" },
      { title: "Web Design", link: "https://www.geeksforgeeks.org/web-design/" },
      { title: "Web Development", link: "https://www.geeksforgeeks.org/web-development/" },
    ],
  },
  {
    title: "Languages",
    links: [
      { title: "Bash", link: "https://www.geeksforgeeks.org/bash-shell-scripting-tutorial/" },
      { title: "C++", link: "https://www.geeksforgeeks.org/c-plus-plus/" },
      { title: "C#", link: "https://www.geeksforgeeks.org/c-sharp-programming-language/" },
      { title: "Go", link: "https://www.geeksforgeeks.org/go-programming-language/" },
      { title: "HTML & CSS", link: "https://www.geeksforgeeks.org/html-css-tutorials/" },
      { title: "Java", link: "https://www.geeksforgeeks.org/java/" },
      { title: "JavaScript", link: "https://www.geeksforgeeks.org/javascript/" },
      { title: "Kotlin", link: "https://www.geeksforgeeks.org/kotlin-programming-language/" },
      { title: "PHP", link: "https://www.geeksforgeeks.org/php-tutorials/" },
      { title: "Python", link: "https://www.geeksforgeeks.org/python-programming-language/" },
      { title: "R", link: "https://www.geeksforgeeks.org/r-programming-language/" },
      { title: "Ruby", link: "https://www.geeksforgeeks.org/ruby-programming-language/" },
      { title: "SQL", link: "https://www.geeksforgeeks.org/sql-tutorial/" },
      { title: "Swift", link: "https://www.geeksforgeeks.org/swift-programming-language/" },
    ],
  },
  {
    title: "Career building",
    links: [
      { title: "Career paths", link: "https://www.geeksforgeeks.org/career-path-for-software-engineer/" },
      { title: "Career services", link: "https://www.geeksforgeeks.org/career-services/" },
      { title: "Interview prep", link: "https://www.geeksforgeeks.org/interview-preparation-for-software-developer/" },
      { title: "Professional certification", link: "https://www.geeksforgeeks.org/certification-courses-on-geeksforgeeks/" },
      { title: "Full Catalog", link: "https://practice.geeksforgeeks.org/courses" },
      { title: "Beta Content", link: "https://www.geeksforgeeks.org/beta-program/" },
    ],
  },
];
